export enum IDataListTypes {
  LIST_DATA_LIST_REQUEST = '@datalist/LIST_DATA_LIST_REQUEST',
  LIST_DATA_LIST_SUCCESS = '@datalist/LIST_DATA_LIST_SUCCESS',
  LIST_DATA_LIST_FAILURE = '@datalist/LIST_DATA_LIST_FAILURE',

  GET_DATA_LIST_REQUEST = '@datalist/GET_DATA_LIST_REQUEST',
  GET_DATA_LIST_SUCCESS = '@datalist/GET_DATA_LIST_SUCCESS',
  GET_DATA_LIST_FAILURE = '@datalist/GET_DATA_LIST_FAILURE',

  GET_DATA_LIST_METADATA_REQUEST = '@datalist/GET_DATA_LIST_METADATA_REQUEST',
  GET_DATA_LIST_METADATA_SUCCESS = '@datalist/GET_DATA_LIST_METADATA_SUCCESS',
  GET_DATA_LIST_METADATA_FAILURE = '@datalist/GET_DATA_LIST_METADATA_FAILURE',

  ACTIVATE_DATA_LIST_REQUEST = '@datalist/ACTIVATE_DATA_LIST_REQUEST',
  ACTIVATE_DATA_LIST_SUCCESS = '@datalist/ACTIVATE_DATA_LIST_SUCCESS',
  ACTIVATE_DATA_LIST_FAILURE = '@datalist/ACTIVATE_DATA_LIST_FAILURE',

  SAVE_DATA_LIST_REQUEST = '@datalist/SAVE_DATA_LIST_REQUEST',
  SAVE_DATA_LIST_SUCCESS = '@datalist/SAVE_DATA_LIST_SUCCESS',
  SAVE_DATA_LIST_FAILURE = '@datalist/SAVE_DATA_LIST_FAILURE',

  CLEAR_DATA_LIST_REQUEST = '@datalist/CLEAR_DATA_LIST_REQUEST',

  GET_METADATA_TEMPLATE_DATA_LIST_REQUEST = '@datalist/GET_METADATA_TEMPLATE_LIST_REQUEST',
  GET_METADATA_TEMPLATE_DATA_LIST_SUCCESS = '@datalist/GET_METADATA_TEMPLATE_LIST_SUCCESS',
  GET_METADATA_TEMPLATE_DATA_LIST_FAILURE = '@datalist/GET_METADATA_TEMPLATE_LIST_FAILURE',

  GET_METADATA_FILE_DATA_LIST_REQUEST = '@datalist/GET_METADATA_FILE_LIST_REQUEST',
  GET_METADATA_FILE_DATA_LIST_SUCCESS = '@datalist/GET_METADATA_FILE_LIST_SUCCESS',
  GET_METADATA_FILE_DATA_LIST_FAILURE = '@datalist/GET_METADATA_FILE_LIST_FAILURE',

  GET_METADATA_FILE_BY_NAME_DATA_LIST_REQUEST = '@datalist/GET_METADATA_FILE_BY_NAME_LIST_REQUEST',
  GET_METADATA_FILE_BY_NAME_DATA_LIST_SUCCESS = '@datalist/GET_METADATA_FILE_BY_NAME_LIST_SUCCESS',
  GET_METADATA_FILE_BY_NAME_DATA_LIST_FAILURE = '@datalist/GET_METADATA_FILE_BY_NAME_LIST_FAILURE',
}

export interface IListDataListRequestAction {
  type: typeof IDataListTypes.LIST_DATA_LIST_REQUEST;
  payload: {
    page: number;
    sortOrder: ISortOrder;
    sortBy: ISortBy;
    limit: number;
    search: string;
  };
}

export interface IListDataListSuccessAction {
  type: typeof IDataListTypes.LIST_DATA_LIST_SUCCESS;
  payload: {
    dataLists: IDataList[];
    sortOrder: ISortOrder;
    sortBy: ISortBy;
    total: number;
  };
}
export interface IListDataListFailureAction {
  type: typeof IDataListTypes.LIST_DATA_LIST_FAILURE;
}
export interface IGetDataListRequestAction {
  type: typeof IDataListTypes.GET_DATA_LIST_REQUEST;
  payload: {
    id: string;
  };
}
export interface IGetDataListSuccessAction {
  type: typeof IDataListTypes.GET_DATA_LIST_SUCCESS;
  payload: {
    dataList: IDataList;
  };
}
export interface IGetDataListFailureAction {
  type: typeof IDataListTypes.GET_DATA_LIST_FAILURE;
}
export interface IGetDataListMetadataRequestAction {
  type: typeof IDataListTypes.GET_DATA_LIST_METADATA_REQUEST;
  payload: {
    formFieldId: string;
    parentFormFieldValue: string;
    search: string;
    page: number;
    limit: number;
  };
}
export interface IGetDataListMetadataSuccessAction {
  type: typeof IDataListTypes.GET_DATA_LIST_METADATA_SUCCESS;
  payload: {
    total: number;
    metadata: IDataListMetadata[];
  };
}
export interface IGetDataListMetadataFailureAction {
  type: typeof IDataListTypes.GET_DATA_LIST_METADATA_FAILURE;
}

export interface IActivateDataListRequestAction {
  type: typeof IDataListTypes.ACTIVATE_DATA_LIST_REQUEST;
  payload: {
    data_list_id: string;
    active: boolean;
  };
}
export interface IActivateDataListSuccessAction {
  type: typeof IDataListTypes.ACTIVATE_DATA_LIST_SUCCESS;
  payload: {
    data_list_id: string;
    active: boolean;
  };
}
export interface IActivateDataListFailureAction {
  type: typeof IDataListTypes.ACTIVATE_DATA_LIST_FAILURE;
}

export interface ISaveDataListRequestAction {
  type: typeof IDataListTypes.SAVE_DATA_LIST_REQUEST;
  payload: {
    id: string | null;
    name: string;
    form_field_id: string;
    form_field_label: string;
    active: boolean;
    parent_id: string | null;
    responsible: string;
  };
}
export interface ISaveDataListSuccessAction {
  type: typeof IDataListTypes.SAVE_DATA_LIST_SUCCESS;
}
export interface ISaveDataListFailureAction {
  type: typeof IDataListTypes.SAVE_DATA_LIST_FAILURE;
}

export interface IClearDataListRequestAction {
  type: typeof IDataListTypes.CLEAR_DATA_LIST_REQUEST;
}

export interface IGetMetadataTemplateDataListRequestAction {
  type: typeof IDataListTypes.GET_METADATA_TEMPLATE_DATA_LIST_REQUEST;
}
export interface IGetMetadataTemplateDataListSuccessAction {
  type: typeof IDataListTypes.GET_METADATA_TEMPLATE_DATA_LIST_SUCCESS;
}
export interface IGetMetadataTemplateDataListFailureAction {
  type: typeof IDataListTypes.GET_METADATA_TEMPLATE_DATA_LIST_FAILURE;
}

export interface IGetMetadataFileDataListRequestAction {
  type: typeof IDataListTypes.GET_METADATA_FILE_DATA_LIST_REQUEST;
  payload: {
    data_list_id: string;
  };
}
export interface IGetMetadataFileDataListSuccessAction {
  type: typeof IDataListTypes.GET_METADATA_FILE_DATA_LIST_SUCCESS;
}
export interface IGetMetadataFileDataListFailureAction {
  type: typeof IDataListTypes.GET_METADATA_FILE_DATA_LIST_FAILURE;
}

export interface IGetMetadataFileByNameDataListRequestAction {
  type: typeof IDataListTypes.GET_METADATA_FILE_BY_NAME_DATA_LIST_REQUEST;
  payload: {
    filePath: string;
  };
}
export interface IGetMetadataFileByNameDataListSuccessAction {
  type: typeof IDataListTypes.GET_METADATA_FILE_BY_NAME_DATA_LIST_SUCCESS;
}
export interface IGetMetadataFileByNameDataListFailureAction {
  type: typeof IDataListTypes.GET_METADATA_FILE_BY_NAME_DATA_LIST_FAILURE;
}

export type IDataListActionsType =
  | IListDataListRequestAction
  | IListDataListSuccessAction
  | IListDataListFailureAction
  | IGetDataListRequestAction
  | IGetDataListSuccessAction
  | IGetDataListFailureAction
  | IGetDataListMetadataRequestAction
  | IGetDataListMetadataSuccessAction
  | IGetDataListMetadataFailureAction
  | IActivateDataListRequestAction
  | IActivateDataListSuccessAction
  | IActivateDataListFailureAction
  | ISaveDataListRequestAction
  | ISaveDataListSuccessAction
  | ISaveDataListFailureAction
  | IClearDataListRequestAction
  | IGetMetadataTemplateDataListRequestAction
  | IGetMetadataTemplateDataListSuccessAction
  | IGetMetadataTemplateDataListFailureAction
  | IGetMetadataFileDataListRequestAction
  | IGetMetadataFileDataListSuccessAction
  | IGetMetadataFileDataListFailureAction
  | IGetMetadataFileByNameDataListRequestAction
  | IGetMetadataFileByNameDataListSuccessAction
  | IGetMetadataFileByNameDataListFailureAction;

export interface ICategory {
  id: string;
  name: string;
  org_id: string;
}

export interface IDataListMetadata {
  id: string;
  data_list_id: string;
  meta_key: string;
  meta_value: string;
  meta_json: string;
}

export interface IDataList {
  id: string;
  name: string;
  org_id: string;
  form_field_id: string;
  form_field_label: string;
  created_by: string;
  updated_by: string;
  created_at: string;
  updated_at: string;
  category: ICategory | null;
  parent: IDataList | null;
  status: 'PENDING' | 'ERROR' | 'IN PROGRESS' | 'FINISHED';
  active: boolean;
}

export interface IDataListState {
  loading: boolean;
  loadingSave: boolean;
  loadingActivation: boolean;
  loadingGetDataList: boolean;
  loadingGetMetadataTemplate: boolean;
  loadingGetMetadataFile: boolean;
  loadingGetMetadataFileByName: boolean;

  sortOrder: ISortOrder;
  sortBy: ISortBy;

  totalDataLists: number;
  totalMetadata: number;

  dataList: IDataList | null;
  dataLists: IDataList[];
  metadata: IDataListMetadata[] | null;
}

export type ISortOrder = 'asc' | 'desc';
export type ISortBy =
  | 'updated_at'
  | 'name'
  | 'form_field_id'
  | 'created_by'
  | 'updated_by'
  | 'active';
